import React from "react";
import { useParams } from "react-router-dom";

export function AutomedManageBooking() {
    const { automedSiteId } = useParams();

    const manageBookingUrl = `${import.meta.env.VITE_AUTOMED_URL}/myhealth/cors_api/${automedSiteId}/myappts?clinic_group_crm=436&user_fk=${automedSiteId}`;

    return <iframe
        className="w-screen h-screen"
        src={manageBookingUrl}
    />
}